__turbopack_context__.v({
  "error": "kwk-form-module-scss-module__0iRdGW__error",
  "form": "kwk-form-module-scss-module__0iRdGW__form",
  "li": "kwk-form-module-scss-module__0iRdGW__li",
  "placeholder": "kwk-form-module-scss-module__0iRdGW__placeholder",
  "spacing": "kwk-form-module-scss-module__0iRdGW__spacing",
  "ul": "kwk-form-module-scss-module__0iRdGW__ul",
});
